import "../Css/Main.css";
import { Link } from "react-router-dom";
import fisrtCardImage from "../Assets/Images/Untitled.png";
import SecondCardImage from "../Assets/Images/Artifical_Intelligence.png";
import ThirdCardImage from "../Assets/Images/Staff.png";
import fourthCardImage from "../Assets/Images/Web-Develop.png";
import fifthCardImage from "../Assets/Images/Mobile_App.png";
import sixthCardImage from "../Assets/Images/ICO-marketing.png";
import seventhCardImage from "../Assets/Images/Digital_Marketing.png";
import eighthCardIamge from "../Assets/Images/UX_Design.png";

const BgServicesCards = () => {
  return (
    <div>
      <div className="bgImg-serviceSection">
        <div className="grid lg:grid-cols-3 gap-4 sm:gap-6 text-white">
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={fisrtCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Metaverse
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              Metaverse is a multidimensional digital space that lies beyond the
              world we live in. It’s a collection of all possible versions of a
              place or object, along with our perception of ownership and rights
              over them.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={SecondCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Artifical Intelligence
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              Leverage the power of Artificial Intelligence to boost your
              business growth. Automate the entire process and achieve quicker
              results.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={ThirdCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Staff Augmentation
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              Hire a qualified team to take care of specific tasks while you
              focus on the core of the business. Increase your productivity with
              a skilled team.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-4 sm:gap-6 text-white">
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={fourthCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Web Development
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              We build websites that are fast and intuitive. Our web solutions
              enable you to enhance your online presence
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={fifthCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Mobile App Development
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              We create robust mobile applications that offer the best user
              experience, regardless of whichever device or platform you’re on.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={sixthCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              ICO Marketing
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              We offer an array of ICO Marketing services to provide sustainable
              results and to make it a huge success.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 gap-4 sm:gap-6 text-white">
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={seventhCardImage} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Digital Marketing
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              We offer Digital Marketing services that help your business with
              lead generation, making sales and increased ROI.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <img className="h-28" src={eighthCardIamge} alt="" />
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              UX Design
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              We aim to deliver ultra-modern & user centric web & mobile
              application designs for your business needs.
            </p>
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </a>
          </div>
          <div className="p-4 sm:p-6 px-4 sm:px-8 lg:px-10 py-12 sm:py-16 lg:py-20 hover:bg-customRed shadow">
            <div className="flex justify-center">
              <svg
                className="h-28 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                />
              </svg>
            </div>
            <h5 className="py-3 text-xl sm:text-2xl lg:text-[28px] font-bold tracking-tight text-white text-center">
              Logistics & Transport
            </h5>
            <p className="mb-3 font-normal text-white text-center text-lg">
              From fleet management and route optimization to dedicated
              transport for universities and educational institutes, we keep
              your business and people moving efficiently.
            </p>
            <Link
              to="/logistics"
              className="flex items-center px-3 py-2 text-sm font-medium text-center text-white justify-center"
            >
              Read more
              <svg
                className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BgServicesCards;
